import { createContext } from 'react';

const ThemeContext = createContext({
  theme: {},
  updateTheme: () => {},
  logo: '',
  updateLogo: () => {},
});

export default ThemeContext;
